<template>
  <b-card class="report_card">
    <span class="content" v-if="have_data">{{data | round}} Accounts / Ledger</span><br/>
    New Account Rate
  </b-card>
</template>

<script>
export default {
  name: 'MetricsAccountRateCard',

  computed : {
    data : function(){
      return this.$store.state.report.data["account_rate"]
    },

    have_data : function(){
      return !!parseFloat(this.data);
    },
  }
}
</script>
